export default "__VITE_ASSET__BvMtU5sv__"